import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ignoreElements, takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { SharedService } from 'src/app/Service/shared.service';
import { sp, Web} from "@pnp/sp/presets/all";
import * as _ from 'lodash';
declare var $:any;

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnInit {
  currentLg ;
  code;
  nwMail='';
  newsLetters=[];
  passerelles= [];
  annees = [];
  openTab = [];
  panelOpenState = false;
  inscription = true;
  bloc = {
    Titre: "",
    Contenu: ""
  }

  constructor(private global: Global,  private shared: SharedService, private router: Router,
    private route: ActivatedRoute) {
    sp.setup({
      sp:{
        baseUrl: this.global._basedUrl
      }
    })
   }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.currentLg = lg;
      this.nwMail =  '';
      this.inscription = true;
      this.newsLetters=[];
      this.passerelles= [];
      this.route.queryParams
      .subscribe(params => {
        if(params !== {} && params !== null && params ['mail'] !== null && params ['mail'] !== undefined ) {
          this.nwMail = params ['mail'];
          const email_footer= document.getElementById('emailinp');
          //@ts-ignore
          email_footer.value = '';
        } else {
          this.nwMail =  '';
        }
        this.shared.getPasserelle(this.global._baseUrlRacine + this.global._FrUrl).subscribe(datas => {
          datas['value'].forEach(element => {
            if(element.ContentType.Name ==='NewsLetters') {
              const obj = {
                url: this.global._baseUrlStatique + element.File.ServerRelativeUrl,
                Title: element.Title.split('-')[1],
                Order: +(element.Title.split('-')[0].trim()),
                Annee: +element.Annee,
              };
             
              this.newsLetters.push(obj);
            } else {
              const obj = {
                url: this.global._baseUrlStatique + element.File.ServerRelativeUrl,
                Title: element.Title,
                Annee: +element.Annee,
              }
              this.passerelles.push(obj);
            }
            if(this.annees.indexOf(+element.Annee)=== - 1) {
                this.annees.push(+element.Annee);
            }
          });
  
          this.newsLetters = _.orderBy(this.newsLetters, ['Annee','Order'], ['desc','asc']);
  
          this.passerelles = _.orderBy(this.passerelles, ['Annee','Title'], ['desc','desc']);  
  
        });
  
        this.shared.getBlocDescriptionByCode(lg.url,'Passerelle1').subscribe(datas => {
          if(datas['value'].length>0) {
            this.bloc.Titre = datas['value'][0].Title;
            this.bloc.Contenu = datas['value'][0].Contenu;
          }
        })
        this.createCaptcha();
      });
      


    });
  }

createCaptcha() {
  //clear the contents of captcha div first 
  document.getElementById('captcha').innerHTML = "";
  let charsArray =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let lengthOtp = 5;
  let captcha = [];
  for (let i = 0; i < lengthOtp; i++) {

    let index = Math.floor(Math.random() * charsArray.length + 1); 
    if (captcha.indexOf(charsArray[index]) == -1)
      captcha.push(charsArray[index]);
    else i--;
  }
  let canv = document.createElement("canvas");
  canv.id = "captcha";
  canv.width = 90;
  canv.height = 40;
  let ctx = canv.getContext("2d");
  ctx.font = "23px Georgia";
  ctx.strokeText(captcha.join(""), 0, 30);
  //storing captcha so that can validate you can save it somewhere else according to your specific requirements
  this.code = captcha.join("");
  document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
}
validateCaptcha() {
   let result = false;

  //@ts-ignore
  if (document.getElementById("cpatchaTextBox").value == this.code) {
    result = true;
  } else{
    
    
    alert("Captcha invalid");
      //@ts-ignore
      document.getElementById("cpatchaTextBox").value = '',
    this.createCaptcha();
  }
  return result
}
addInscription() {
if(this.validateCaptcha()) {
  let list =   Web(this.currentLg.url).lists.getByTitle("NewsLetter");
    list.items.add({
      Title: this.nwMail,
      Adhesion: this.inscription

    }).then(datas => {
     this.nwMail='';
      //@ts-ignore
     document.getElementById("cpatchaTextBox").value = '',
     this.createCaptcha();
      alert("Action enregistrée !!")
    });
}
}
downloadTarget(target) {


    const  targetLink = target;
    var redirect = window.open(targetLink,'_blank');
    redirect.location;
  
}
chargeFancyBox(url) {
  $("#page").attr('src',url );
  $("#myModal").modal("show");
  $('#myModal').on('hide.bs.modal', (e)=>{
    $("#page").attr('src',""); 
}) 
}


}
